import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-user',
    templateUrl: '../svgs/User.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--user'
    },
    standalone: false
})
export class TellerOnlineIconUser {
}
